import React from "react";
import {SimpleTooltip} from "../tooltip";
import {Images} from "utils";

export const PhoneBadge = ({ phone }) => {
    const converted = phone ? '(' + phone.substr(0, 3) + ') ' + phone.substr(3, 3) + '-' + phone.substr(6, 6) : '--';

    return(
        <div className='badge-box-wrapper'>
            <SimpleTooltip title={<a className='badge-link-box' href={`tel:${phone}`}>{converted}</a>} placement="top" arrow>
                    <img style={{width: 16, height: 16}} src={Images.callCalling} alt="phone" />
            </SimpleTooltip>
        </div>
    )
}

export const EmailBadge = ({ email }) => {

    return(
        <div className='badge-box-wrapper'>
            <SimpleTooltip title={<a className='badge-link-box' href={`mailto:${email}`}>{email}</a>} placement="top" arrow>
                <img style={{width: 16, height: 16}} src={Images.sms} alt="email" />
            </SimpleTooltip>
        </div>
    )
}

/**
 * Address icon; the tooltip shows the address (with an optional PO Box first) and links to Google Maps directions.
 * Uses the geocoded point when there is one, else the address text.
 */
export const AddressBadge = ({ address, poBox }) => {
    const text = [poBox, address?.formattedAddress].filter(Boolean).join(', ');
    const destination = address?.lat && address?.lng ? `${address.lat},${address.lng}` : encodeURIComponent(address?.formattedAddress || '');

    return(
        <div className='badge-box-wrapper'>
            <SimpleTooltip
                title={
                    <a
                        className='badge-link-box'
                        href={`https://www.google.com/maps?saddr=My+Location&daddr=${destination}`}
                        target="_blank"
                        rel="noopener noreferrer"
                    >
                        {text}
                    </a>
                }
                placement="top"
                arrow
            >
                <img style={{width: 16, height: 16}} src={Images.grayLocation} alt="address" />
            </SimpleTooltip>
        </div>
    )
}


export const CustomBadge = ({ text, icon }) => {

    return(
        <div className='badge-box-wrapper'>
            <SimpleTooltip title={<p className='badge-link-box' style={{textDecoration:"none"}} >{text}</p>} placement="top" arrow>
                <img style={{width: 16, height: 16}} src={icon} alt="icon" />
            </SimpleTooltip>
        </div>
    )
}


export const BadgeLine = () => {
    return <div className='badge-line-box'/>
}